import { render, staticRenderFns } from "./KnFormEmployee.vue?vue&type=template&id=6a566378"
import script from "./KnFormEmployee.js?vue&type=script&lang=js&external"
export * from "./KnFormEmployee.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports